<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Waters Contracting</h1>
                <p>
                    Our goal at Waters Contracting is to provide you with a worry-free, low maintenance landscape and irrigation system. We accomplish this by providing you with the highest quality products, excellent design, superior installation, and outstanding service.
                </p>
                <p>
                    To better serve you, we separated are services into two categories; Landscaping and Irrigation. Both categories have four steps; Design, Installation, Maintenance, and Management. 
                </p>
                <div>
                  <b-jumbotron header="Landscaping" lead="Landscaping is what makes your home beautiful.">
                    <p>With our services, we create a sanctuary of softscaping around the hardscape features.</p>
                  </b-jumbotron>
                  <b-jumbotron header="Irrigation" lead="Irrigation, aka sprinkler systems, is our specialty.">
                    <p>We believe an efficient irrigation system is essential to keeping your property beautiful.</p>
                  </b-jumbotron>
                  <b-jumbotron header="Design" lead="Begin with the end in mind.">
                    <p>In order to have a good quality landscape and irrigation system, you need to start with a good design.</p>
                  </b-jumbotron>
                  <b-jumbotron header="Installation" lead="New from scratch, or take out the old.">
                    <p>A good installation makes maintenance and management of the landscape and irrigation system easier. </p>
                  </b-jumbotron>
                  <b-jumbotron header="Maintenance" lead="A stitch in time saves nine.">
                    <p>By keeping the landscape maintained and the irrigation system efficient, you maintain the value of your property. </p>
                  </b-jumbotron>
                  <b-jumbotron header="Management" lead="Let others worry.">
                    <p>Proper management of the landscape and irrigation system will prevent damage to the hardscapes on the property and help the plants stay healthy. </p>
                  </b-jumbotron>
                </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Services',
}
</script>